import "./MGButton.css"
export default function MGButton({
    label,
    type,
    onClick,
    isEnable
}) {
    const classButton = "MGButton-" + type

    return (
        <button className={classButton} onClick={onClick} disabled={!isEnable}>
            <span>{label}</span>
        </button>
    );
}